// GA4 (gtag) + Meta Pixel (fbq) conversion events. Base snippets live in
// public/index.html; this only fires events. No PII is ever sent.
const has = (fn) => typeof window !== "undefined" && typeof window[fn] === "function";

const ctx = (label, params) => ({
  button_label: label,
  page_path: window.location.pathname,
  page_location: window.location.href,
  page_title: document.title,
  ...params,
});

export function track({ gaEvent, metaEvent, metaCustom = false, label, params = {} }) {
  const data = ctx(label, params);
  if (has("gtag")) window.gtag("event", gaEvent, data);
  if (has("fbq") && metaEvent) {
    window.fbq(metaCustom ? "trackCustom" : "track", metaEvent, { content_name: label, page_path: data.page_path, ...params });
  }
  if (process.env.NODE_ENV !== "production") console.debug("[analytics]", gaEvent, metaEvent, data);
}

export const trackContactForm = () =>
  track({ gaEvent: "generate_lead", metaEvent: "Contact", label: "Contact form submit", params: { method: "contact_form", form_id: "contact" } });

export const trackQuoteCalculated = (weightKg) =>
  track({ gaEvent: "view_item", metaEvent: "ViewContent", label: "Quote calculated", params: { method: "calculator", weight_kg: weightKg } });

function classify(a) {
  const href = a.getAttribute("href") || "";
  const label = (a.innerText || a.getAttribute("aria-label") || a.textContent || "").trim().slice(0, 80) || href;
  if (/wa\.me|whatsapp/i.test(href)) return { gaEvent: "generate_lead", metaEvent: "Lead", label, params: { method: "whatsapp", destination: "whatsapp" } };
  if (href.startsWith("tel:")) return { gaEvent: "contact_link", metaEvent: "Contact", label, params: { method: "phone" } };
  if (href.startsWith("mailto:")) return { gaEvent: "contact_link", metaEvent: "Contact", label, params: { method: "email" } };
  if (/shipoms\.in\/book|^\/book(-pickup)?$/i.test(href)) return { gaEvent: "begin_checkout", metaEvent: "InitiateCheckout", label, params: { method: "booking_app", destination: "shipoms" } };
  if (/shipoms\.in\/track|^\/track(ing)?$/i.test(href)) return { gaEvent: "track_shipment", metaEvent: "TrackShipment", metaCustom: true, label, params: { destination: "shipoms" } };
  if (/shipoms\.in\/register|^\/(signup|register)$/i.test(href)) return { gaEvent: "sign_up", metaEvent: "CompleteRegistration", label, params: { method: "shipoms" } };
  if (/shipoms\.in\/login|^\/(signin|login|dashboard)$/i.test(href)) return { gaEvent: "login", metaEvent: "ShipOMSLogin", metaCustom: true, label, params: { method: "shipoms" } };
  return null;
}

let installed = false;
export function initConversionTracking() {
  if (installed || typeof document === "undefined") return;
  installed = true;
  document.addEventListener(
    "click",
    (e) => {
      const a = e.target && e.target.closest && e.target.closest("a[href]");
      if (!a) return;
      const ev = classify(a);
      if (ev) track(ev);
    },
    { capture: true, passive: true }
  );
}

// Meta Pixel PageView for SPA route changes (index.html already fires the
// first one; GA4 Enhanced Measurement handles history changes itself).
export function trackRouteChange(pathname) {
  if (trackRouteChange.last === undefined) { trackRouteChange.last = pathname; return; }
  if (trackRouteChange.last === pathname) return;
  trackRouteChange.last = pathname;
  if (has("fbq")) window.fbq("track", "PageView");
}
